<template>
  <div ref="dropdownRef" class="relative h-full">
    <button
      class="flex items-center text-semantic-primary-on-light h-full px-2 hover:text-semantic-inverse-primary"
      @click.prevent="toggleDropdown"
    >
      <span class="lg:mr-3 overflow-hidden border rounded-full h-10 w-10 font-bold border-semantic-inverse-container-lowest">
        <img
          v-if="userDetails.picture"
          class=""
          :alt="userDetails.given_name"
          :src="userDetails.picture"
          width="40"
          height="40"
          @error="profileImgFallback($event, userDetails.full_name)"
        />
      </span>

      <span 
        class="mr-1 font-bold text-sm hidden lg:block whitespace-nowrap max-w-40 truncate"
        :class="{
          'text-semantic-inverse-primary': dropdownOpen
        }"
      >
        {{ userDetails.given_name }}
      </span>

      <IconsChevronDown 
        :class="{
          'hidden lg:block': true, 
          'rotate-180 text-semantic-inverse-primary': dropdownOpen 
        }" />
    </button>

    <!-- Dropdown Start -->
    <div
      v-if="dropdownOpen"
      class="absolute right-0 flex w-[260px] z-[999] flex-col rounded-b-xl border-0 p-3 border-semantic-inverse-surface-light bg-semantic-inverse-container-lowest shadow-xl"
    >
      <div class="text-left px-3">
        <span class="block font-bold text-sm text-semantic-primary-on-light truncate">
          {{ userDetails.full_name }}
        </span>
        <span class="mt-0.5 block text-xs text-semantic-primary-on-light truncate">
          {{ userDetails.email }}
        </span>
      </div>

      <ul class="flex flex-col gap-1 pt-4 pb-3 border-b border-semantic-inverse-surface-light">
        <li v-for="item in menuItems" :key="item.href">
          <NuxtLink
            :id="item.id"
            :to="item.href"
            class="flex items-center gap-3 px-3 py-2 font-medium rounded-lg group text-sm text-semantic-primary-on-default hover:bg-white/5 hover:text-semantic-primary-on-light"
            :target="item.target || '_self'"
          >
            <!-- SVG icon would go here -->
            <component
              :is="item.icon"
              width="24"
              height="24"
              fill="currentColor"
              class="text-semantic-primary-on-default group-hover:text-semantic-primary-on-light"
            />
            {{ item.text }}
          </NuxtLink>
        </li>
      </ul>
      <NuxtLink
        id="auth_logout_btn"
        type="button"
        class="flex items-center gap-3 px-3 py-2 mt-3 font-medium rounded-lg group text-sm text-semantic-primary-on-default hover:bg-white/5 hover:text-semantic-primary-on-light cursor-pointer"
        @click="signOut"
      >
        <V2IconsSignOut
          width="24"
          height="24"
          fill="currentColor"
          class="text-semantic-primary-on-default group-hover:text-semantic-primary-on-light"
        />
        Sign out
      </NuxtLink>
    </div>
    <!-- Dropdown End -->
  </div>
</template>

<script setup>
import IconsChevronDown from '@/components/icons/ChevronDown.vue'

const userStore = useUserStore()
const appStore = useLayoutsStore()
const router = useRouter()

const dropdownOpen = ref(false)
const dropdownRef = ref(null)

const menuItems = [
  { id: 'dashboard_nav_btn', href: '/dashboard/', icon: resolveComponent('V2IconsHome'), text: 'Dashboard' },
  { id: 'account_settings_nav_btn', href: '/dashboard/account-settings/', icon: resolveComponent('V2IconsCog'), text: 'Account settings' },
  { id: 'support_nav_btn', href: 'https://support.compareclub.com.au/en/collections/9254046-club-account-management', icon: resolveComponent('V2IconsBuoy'), text: 'Support', target: '_blank' },
  { id: 'legal_nav_btn', href: '/dashboard/legal/', icon: resolveComponent('V2IconsBookOpenText'), text: 'Legal' }
]

const userDetails = computed(() => userStore.getUserProfile)

const toggleDropdown = () => {
  dropdownOpen.value = !dropdownOpen.value
}

const closeDropdown = () => {
  dropdownOpen.value = false
}

const signOut = () => {
  // Sign Out
  appStore.setPageLoader(true)
  nextTick().then(() => {
    userStore.logout()
      .finally(() => {
        router.push(generateLoginPageUrl())
        appStore.setPageLoader(false)
      })
  })
  closeDropdown()
}

const handleClickOutside = event => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    closeDropdown()
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>
